import { IApplePayCouponCodeCallbackActions } from "../../models/IApplePayCouponCodeCallbackActions";
import { IJwtEnhancedApplePayCouponCodeUpdate } from "../../models/IJwtEnhancedApplePayCouponCodeUpdate";
import { RequestJwtUpdateHandler } from "../../../../../application/core/services/st-codec/RequestJwtUpdateHandler";
import { IApplePaySession } from "../../models/IApplePaySession";
import { ApplePayErrorUtils } from "./ApplePayErrorUtils";

export class ApplePayCouponCodeResolver implements IApplePayCouponCodeCallbackActions {
  constructor(
    private readonly session: IApplePaySession,
    private readonly jwtRequestHandler: RequestJwtUpdateHandler,
  ) {}

  public resolve(param: IJwtEnhancedApplePayCouponCodeUpdate): void {
    this.handleCouponCodeUpdate(param);
  }

  private handleCouponCodeUpdate(
    param: IJwtEnhancedApplePayCouponCodeUpdate,
  ): void {
    if (
      param.errors &&
      param.errors.length > 0 &&
      ApplePayErrorUtils.isApplePayErrorAvailable()
    ) {
      param.errors = ApplePayErrorUtils.setApplePayErrorForAppleDevice(
        param.errors,
      );
    }
    this.session.completeCouponCodeChange(param);
    this.handleJwtUpdate(param);
  }

  private handleJwtUpdate(param: IJwtEnhancedApplePayCouponCodeUpdate): void {
    if (param.jwt) {
      this.jwtRequestHandler.request(param.jwt);
    }
  }
}
